import SyosEvents from './utils/SyosEvents';
import SyosUiContainer from './SyosUiContainer';
import SyosPageComponent from './SyosPageComponent';

/** @typedef {import("./SyosController").default} SyosController */
/** @typedef {import("../tnew/currency/CurrencyFormatter").default} CurrencyFormatter */


const CLASS_BASE = 'tn-syos-mobile-cart-controls';
const CLASS_BTN_VIEW_CART = `${CLASS_BASE}__btn-view-cart`;
const CLASS_BTN_VIEW_CART_LABEL = `${CLASS_BTN_VIEW_CART}-label`;
const CLASS_BTN_ADD_TO_CART = 'tn-syos__btn-add-to-cart';

const HTML = `
  <button type="button" class="${CLASS_BTN_VIEW_CART} tn-syos-mobile-cart-controls__item">
    <span class="glyphicon glyphicon-shopping-cart ${CLASS_BTN_VIEW_CART}-icon"></span>
    <span class="${CLASS_BTN_VIEW_CART_LABEL}">View Seats</span>
  </button>

  <div class="${CLASS_BASE}__summary tn-syos-mobile-cart-controls__item">
    <div class="${CLASS_BASE}__summary-subtotal"></div>
    <div class="${CLASS_BASE}__summary-seat-count"></div>
  </div>

  <button type="button" class="${CLASS_BTN_ADD_TO_CART} ${CLASS_BTN_ADD_TO_CART}--cart-control tn-syos-mobile-cart-controls__item"></button>
`;

class SyosMobileCartControls extends SyosUiContainer {
  /**
   * @param {SyosController} syosController
   * @param {CurrencyFormatter} currencyFormatter
   */
  constructor(syosController, currencyFormatter) {
    super(syosController, `.${CLASS_BASE}`);
    this.bindMethods();

    this.currencyFormatter = currencyFormatter;

    this.$el.hide();
    this.$el.html(HTML);

    this.$btnToggleCart = this.find(`.${CLASS_BTN_VIEW_CART}`);
    this.$btnAddToCart = this.find(`.${CLASS_BTN_ADD_TO_CART}`);

    this.$subtotal = this.find('.tn-syos-mobile-cart-controls__summary-subtotal');
    this.$seatCount = this.find('.tn-syos-mobile-cart-controls__summary-seat-count');

    this.$btnToggleCart.on('click', () => {
      this.syosController.emit(SyosEvents.CART_DETAILS_TOGGLE);
    });

    this.$btnAddToCart.html(SyosPageComponent.addToCartButton);
    this.$btnAddToCart.on('click', () => {
      this.syosController.emit(SyosEvents.RESERVE_SEATS);
    });

    this.syosController.once(SyosEvents.SCREENS_DATA_LOADED, () => this.$el.show());
    this.syosController.on(SyosEvents.CART_UPDATE, this.onCartUpdate);

    this.update();
  }

  bindMethods() {
    this.onCartUpdate = this.onCartUpdate.bind(this);
  }

  onCartUpdate({ cart }) {
    this.update(cart.getSeatCount(), cart.getSubtotal());
  }

  update(seatCount = 0, subtotal = 0) {
    const subtotalDisplay = this.currencyFormatter.format(subtotal);
    const seatOrSeats = seatCount === 1 ? 'Seat' : 'Seats';
    const isDisabled = seatCount === 0;

    this.$seatCount.html(`${seatCount} ${seatOrSeats}`);
    this.$subtotal.html(subtotalDisplay);

    this.$btnToggleCart.prop('disabled', isDisabled);
    this.$btnAddToCart.prop('disabled', isDisabled);
  }
}

export default SyosMobileCartControls;



// WEBPACK FOOTER //
// ./V7/syos/SyosMobileCartControls.js